import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom'
import { Body, DivDigital, BotaoLeft, TopoSeta } from './style'
import SetaEsquerda from '../img/Seta_Esquerda.png';
import { SiteTopo } from "../topo";

export const CalcDigital = () => {

    const [focused, setFocused] = useState(false)


    const [radio, setRadio] = useState('1')
    const [etqquantidade, setEtqquantidade] = useState('1000')
    const [etqlargura, setEtqlargura] = useState('100') // Não esta funcionando
    const [etqaltura, setEtqaltura] = useState('100')
    const [total, setTotal] = useState('')
    const [retornoTotal, setRetornoTotal] = useState('')
    const [emailDestino, setEmailDestino] = useState('')
    const [emailEnviado, setEmailEnviado] = useState(false)
    const [percComissao, setPercComissao] = useState('10')
    const [acabamento, setAcabamento] = useState(false)
    const [plastificacao, setPlastificacao] = useState(false)
    // eslint-disable-next-line no-unused-vars
    const [debugCalc, setDebugCalc] = useState({})
    const [sugestaoInversao, setSugestaoInversao] = useState(null)

    const nomesMateriais = {
        '1': 'Couche',
        '2': 'Bopp Fosco/Brilho (Cola Acilica 20gr)',
        '3': 'Bopp Fosco (Cola Borracha 30gr)',
        '6': 'Bopp Transparente',
        '7': 'Bopp Prata',
        '8': 'Vinil Branco',
        '5': 'Couche Relevo (Especial P/ Vinho e Chocolate)',
    }

    var MateriaPrima = '';
    const Couche = 3;
    const Bopp_20gr = 4;
    const Bopp_30gr = 4.4;
    const Bopp_Prata = 10;
    const Bopp_Transp = 7;
    const Vinil = 15;
    const Couche_Esp_Vergara = 15;

    (radio === '1') ? MateriaPrima = Couche :
        (radio === '2') ? MateriaPrima = Bopp_20gr :
            (radio === '3') ? MateriaPrima = Bopp_30gr :
                (radio === '5') ? MateriaPrima = Couche_Esp_Vergara :
                    (radio === '6') ? MateriaPrima = Bopp_Transp :
                        (radio === '7') ? MateriaPrima = Bopp_Prata :
                            (radio === '8') ? MateriaPrima = Vinil :
                                <></>

    useEffect(() => {
        setRetornoTotal(total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))
    }, [total])

    useEffect(() => {
        (focused === false) ?
            calcular()
            : <></>
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [focused])

    useEffect(() => {
        calcular()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [etqquantidade, etqlargura, etqaltura, radio, percComissao, acabamento, plastificacao])


    // ----- Parâmetros do modelo de custo (ajustar conforme a realidade do negócio) -----
    const CUSTO_CLICK_POR_METRO = 2.30      // R$ por metro linear de mídia impresso
    const MEDIA_LARGURA_MM = 330            // largura da bobina (matéria-prima) comprada
    const CORTE_LIMITE_MM = 290             // janela de corte da máquina (usada para a largura/carreiras)
    const GAP_LARGURA_MM = 3                // espaço entre colunas (carreiras) na largura
    const GAP_ALTURA_MM = 4                 // espaço entre fileiras ao longo do comprimento

    const LIMITE_CORTE_PEQUENA_MM = 45      // etiquetas com o menor lado <= 45mm custam mais para cortar
    const PRECO_CORTE_PEQUENA = 0.04        // R$ por etiqueta (menor lado <= 45mm)
    const PRECO_CORTE_GRANDE = 0.03         // R$ por etiqueta (menor lado > 45mm)

    // Perda de material: percentual progressivo por faixa de M² (tipo IR — cada faixa só se
    // aplica à fatia de M² dentro dela, sem "degrau" que faria pedido maior sair mais barato).
    const FAIXAS_PERDA_MATERIAL = [
        { de: 0, ate: 15, percentual: 0.10 },
        { de: 15, ate: 20, percentual: 0.08 },
        { de: 20, ate: 30, percentual: 0.05 },
        { de: 30, ate: Infinity, percentual: 0.03 },
    ]

    // Margem: multiplicador do custo de click, também progressivo por faixa de M².
    const LIMITE_M2_ETIQUETA_PEQUENA = 5.3
    const FAIXAS_MARGEM_MULTIPLICADOR = [
        { de: 0, ate: LIMITE_M2_ETIQUETA_PEQUENA, multiplicador: 1.25 },
        { de: LIMITE_M2_ETIQUETA_PEQUENA, ate: Infinity, multiplicador: 1 },
    ]

    // Calcula a taxa/multiplicador médio efetivo quando o valor é dividido em faixas progressivas
    // (cada faixa só pesa pela fatia do total que cai dentro dela, igual tabela de IR).
    const taxaProgressiva = (valorTotal, faixas, campo) => {
        let acumulado = 0
        for (const faixa of faixas) {
            if (valorTotal <= faixa.de) break
            const fatiaNaFaixa = Math.min(valorTotal, faixa.ate) - faixa.de
            acumulado += fatiaNaFaixa * faixa[campo]
        }
        return valorTotal > 0 ? acumulado / valorTotal : 0
    }

    // Comissão: até 5% calcula normal (sem acréscimo). Acima de 5%, soma um acréscimo por faixa.
    const FAIXAS_COMISSAO_ACIMA_DE_5 = [
        { ate: 6, acrescimo: 1 },
        { ate: 7, acrescimo: 1.5 },
        { ate: 8, acrescimo: 2 },
        { ate: 9, acrescimo: 2.5 },
        { ate: 10, acrescimo: 3 },
    ]

    // Calcula o orçamento completo para uma combinação largura x altura (função pura, reaproveitada
    // para o cálculo normal e para a simulação "invertida" usada na sugestão de economia).
    const computarOrcamento = (largura, altura) => {

        const quantidade = Number(etqquantidade)

        // Quantas colunas (carreiras) de etiqueta cabem na largura cortável de 290mm
        const carreiras = Math.max(1, Math.trunc(CORTE_LIMITE_MM / (largura + GAP_LARGURA_MM)))

        // Quantas fileiras são necessárias para produzir a quantidade total (sempre arredonda pra cima)
        const totalFileiras = Math.ceil(quantidade / carreiras)

        // Custo de Click (impressão) — metro linear = fileiras x (altura + espaço entre fileiras)
        const metroLinear = totalFileiras * (altura + GAP_ALTURA_MM) / 1000
        const custoClick = metroLinear * CUSTO_CLICK_POR_METRO

        // Custo de MP (matéria-prima) — metro quadrado = metro linear x largura da bobina (330mm)
        const metroQuadrado = metroLinear * (MEDIA_LARGURA_MM / 1000)
        const PLASTIFICACAO_ACRESCIMO_MP = 2.00 // R$ a mais por m² de matéria-prima
        const materiaPrimaAjustada = MateriaPrima + (plastificacao ? PLASTIFICACAO_ACRESCIMO_MP : 0)
        const custoMP = metroQuadrado * materiaPrimaAjustada

        // Custo de Corte — por etiqueta, conforme o menor lado
        const menorLado = Math.min(largura, altura)
        const precoCorteUnitario = menorLado <= LIMITE_CORTE_PEQUENA_MM ? PRECO_CORTE_PEQUENA : PRECO_CORTE_GRANDE
        const custoCorte = precoCorteUnitario * quantidade

        const custosBase = custoClick + custoMP + custoCorte

        // Perda de material — percentual progressivo conforme o M² usado, sobre todos os custos base
        const percentualPerdaEfetivo = taxaProgressiva(metroQuadrado, FAIXAS_PERDA_MATERIAL, 'percentual')
        const perdaMaterial = custosBase * percentualPerdaEfetivo

        // Margem = multiplicador progressivo do custo de click (etiquetas pequenas, M² < 5,3,
        // levam mais tempo no acabamento e pesam até 2x; acima disso pesa 1x)
        const multiplicadorMargemEfetivo = taxaProgressiva(metroQuadrado, FAIXAS_MARGEM_MULTIPLICADOR, 'multiplicador')
        const margem = custoClick * multiplicadorMargemEfetivo

        const subtotal = custosBase + perdaMaterial
        const baseAntesAcabamento = custosBase + perdaMaterial + margem

        // Acabamento (por 1 carreira) — acréscimo de 30%, entra antes da comissão
        const ACABAMENTO_ACRESCIMO_PERC = 0.30
        const baseComissao = acabamento ? baseAntesAcabamento * (1 + ACABAMENTO_ACRESCIMO_PERC) : baseAntesAcabamento

        // Comissão é sempre a última a ser calculada, sobre tudo (custos + perda + margem + acabamento)
        const comissaoDigitada = Math.min(10, Math.max(0, Number(percComissao) || 0))
        let comissaoPercEfetivo = comissaoDigitada
        if (comissaoDigitada > 5) {
            const faixaComissao = FAIXAS_COMISSAO_ACIMA_DE_5.find(f => comissaoDigitada <= f.ate)
            comissaoPercEfetivo = comissaoDigitada + faixaComissao.acrescimo
        }
        const comissao = baseComissao * (comissaoPercEfetivo / 100)

        const totalAntesMinimo = baseComissao + comissao

        // Pedido mínimo: piso simples de R$150. Qualquer fórmula baseada em "diferença até 150 + %"
        // (fixa ou escalonada) faz o coeficiente do valor bruto ficar negativo abaixo do piso, o que
        // inverte a ordem (pedido maior sai mais barato). O piso puro não tem esse problema.
        const VALOR_BASE_MINIMO = 150
        const total = Math.max(totalAntesMinimo, VALOR_BASE_MINIMO)
        const valorPorM2 = total / metroQuadrado

        return {
            total,
            debug: {
                carreiras, totalFileiras, metroLinear, metroQuadrado,
                custoClick, custoMP, custoCorte, perdaMaterial, percentualPerdaEfetivo, comissaoPercEfetivo,
                subtotal, comissao, margem, multiplicadorMargemEfetivo, baseComissao, totalAntesMinimo, total, valorPorM2,
            }
        }
    }

    const calcular = () => {

        const largura = Number(etqlargura)
        const altura = Number(etqaltura)

        const resultado = computarOrcamento(largura, altura)
        setTotal(resultado.total)
        setDebugCalc(resultado.debug)

        // Sugestão: se girar a etiqueta 90° (trocar largura por altura) sair mais barato, avisa o usuário
        if (largura !== altura) {
            const resultadoInvertido = computarOrcamento(altura, largura)
            if (resultadoInvertido.total < resultado.total - 0.005) {
                setSugestaoInversao({
                    totalAtual: resultado.total,
                    totalInvertido: resultadoInvertido.total,
                    economia: resultado.total - resultadoInvertido.total,
                })
            } else {
                setSugestaoInversao(null)
            }
        } else {
            setSugestaoInversao(null)
        }
    };

    const orcamentoValido = !!((etqaltura) <= 290 & (etqaltura > 24) & (etqlargura) < 291 & (etqlargura > 24) & (etqquantidade > 99))

    const enviarPorEmail = () => {
        if (!emailDestino) return

        const assunto = encodeURIComponent('Orçamento de Etiquetas - Impressão Digital')
        const corpo = encodeURIComponent(
            'Confira o orçamento solicitado no site da EPC:\n\n' +
            `Material: ${nomesMateriais[radio]}\n` +
            `Quantidade: ${Number(etqquantidade).toLocaleString('pt-br')} etiquetas\n` +
            `Largura: ${etqlargura} mm\n` +
            `Altura: ${etqaltura} mm\n` +
            `Valor total: ${retornoTotal}\n`
        )

        window.location.href = `mailto:${emailDestino}?subject=${assunto}&body=${corpo}`
        setEmailEnviado(true)
    }

    const larguraNum = Number(etqlargura) || 0
    const alturaNum = Number(etqaltura) || 0
    const colunas = larguraNum > 0 ? Math.max(1, Math.trunc(300 / (larguraNum + 3))) : 0

    const AREA_DESENHO_VW = 14
    const GAP_DESENHO_VW = 0.3
    const MAX_ALTURA_DESENHO_VW = 7

    let larguraRetVw = colunas > 0 ? (AREA_DESENHO_VW - GAP_DESENHO_VW * (colunas - 1)) / colunas : 0
    let alturaRetVw = larguraNum > 0 ? larguraRetVw * (alturaNum / larguraNum) : 0

    if (alturaRetVw > MAX_ALTURA_DESENHO_VW) {
        const fator = MAX_ALTURA_DESENHO_VW / alturaRetVw
        alturaRetVw = MAX_ALTURA_DESENHO_VW
        larguraRetVw = larguraRetVw * fator
    }

    return (
        <>

            <Body>

                <TopoSeta>
                    <BotaoLeft>
                        <Link to='/'>
                            <img className="left" src={SetaEsquerda} alt="seta voltar pagina inicial" />
                        </Link>
                    </BotaoLeft>
                    <SiteTopo />
                </TopoSeta>

                <DivDigital>
                    <div className="CalcDigital">

                        <div className="topo">
                            <div>Impressão Digital<br />
                                Orçamento de Etiquetas</div>
                        </div>

                        <hr />

                            <div className="titulo">
                                <div className="subtitulo">Selecione o Material</div>
                                <select
                                    name='radio' value={radio}
                                    onFocus={() => setFocused(true)}
                                    onBlur={() => setFocused(false)}
                                    onChange={e => setRadio(e.target.value)}>
                                    <option value="1" >COUCHE</option>
                                    <option value="2">BOPP FOSCO/BRILHO (Cola Acilica 20gr)</option>
                                    <option value="3">BOPP FOSCO (Cola Borracha 30gr)</option>
                                    <option value="6">BOPP TRANSPARENTE</option>
                                    <option value="7">BOPP PRATA</option>
                                    <option value="8">VINIL BRANCO</option>
                                    <option value="5">COUCHE VERGARA (Especial P/ Vinho e Chocolate)</option>
                                </select>
                                {
                                (radio === '6' || radio === '7') &&
                                    <div className="alerta vermelho">** Sem fundo branco</div>
                                }
                            </div>

                        <div className="titulo">
                            <div className="subtitulo">Quantidade de Etiquetas</div>
                            <div className="alerta">Minimo de 100</div>
                            <input
                                type="number" name='etqquantidade' value={etqquantidade}
                                onChange={(e) => setEtqquantidade(e.target.value)}
                                onFocus={() => setFocused(true)}
                                onBlur={() => setFocused(false)}
                            />
                        </div>

                        <div className="titulo">
                            <div className="subtitulo">Largura da Etiqueta (mm) <span className="seta-medida">&#8596;</span></div>
                            <div className="alerta">Minimo de 25 e maximo de 290</div>
                            <input
                                type="number" name='etqlargura' value={etqlargura}
                                onChange={(e) => setEtqlargura(e.target.value)}
                                onFocus={() => setFocused(true)}
                                onBlur={() => setFocused(false)}
                            />
                        </div>

                        <div className="titulo-linha">
                            <div className="coluna-campos">
                                <div className="titulo">
                                    <div className="subtitulo">Altura da Etiqueta (mm) <span className="seta-medida">&#8597;</span></div>
                                    <div className="alerta">minimo de 25 e maximo de 290</div>
                                    <input
                                        type="number" name='etqaltura' value={etqaltura}
                                        onChange={(e) => setEtqaltura(e.target.value)}
                                        onFocus={() => setFocused(true)}
                                        onBlur={() => setFocused(false)}
                                    />
                                </div>

                                <div className="titulo">
                                    <div className="subtitulo">Comissão (%)</div>
                                    <div className="alerta">Máximo de 10%</div>
                                    <input
                                        type="number" name='percComissao' value={percComissao} min="0" max="10"
                                        onChange={(e) => setPercComissao(e.target.value)}
                                        onFocus={() => setFocused(true)}
                                        onBlur={() => setFocused(false)}
                                    />
                                </div>
                            </div>

                            {
                            sugestaoInversao &&
                                <div className="sugestao-inversao">
                                    <div>💡 Aproveitamento de Mídia</div>
                                    <div>{etqaltura} x {etqlargura} = {sugestaoInversao.totalInvertido.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</div>
                                    <div>💰 economia de {sugestaoInversao.economia.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</div>
                                </div>
                            }
                        </div>

                        <div className="titulo checkbox-linha">
                            <label>
                                <input
                                    type="checkbox" name='acabamento' checked={acabamento}
                                    onChange={(e) => setAcabamento(e.target.checked)}
                                />
                                Acabamento (por 1 carreira)
                            </label>

                            <label>
                                <input
                                    type="checkbox" name='plastificacao' checked={plastificacao}
                                    onChange={(e) => setPlastificacao(e.target.checked)}
                                />
                                Plastificação
                            </label>
                        </div>

                        <div className="botao-auto">
                            <button onClick={calcular}>***** CALCULO AUTOMÁTICO *****</button>
                        </div>

                        {
                        orcamentoValido
                            ?
                            <div className="resultado sucesso">
                                O total de {Number(etqquantidade).toLocaleString('pt-br')} etiquetas é {retornoTotal} </div>
                            : <p className="resultado pendente">Preencha todos os campos !!!</p>
                        }

                        {
                        orcamentoValido &&
                            <div className="envio">
                                <div className="subtitulo">Receber este orçamento por e-mail</div>
                                <div className="campo-email">
                                    <input
                                        type="email" name='emailDestino' placeholder="seuemail@exemplo.com" value={emailDestino}
                                        onChange={(e) => { setEmailDestino(e.target.value); setEmailEnviado(false) }}
                                    />
                                    <button type="button" onClick={enviarPorEmail}>Enviar</button>
                                </div>
                                {
                                emailEnviado &&
                                    <div className="envio-status">Abrindo seu aplicativo de e-mail...</div>
                                }
                            </div>
                        }
                    </div>

                    <div className="Disposicao">

                        <div className="topo">Disposição na Mídia</div>

                        <hr />

                        {
                        colunas > 0
                            ?
                            <>
                                <div className="subtitulo centro">
                                    {colunas} etiqueta{colunas === 1 ? '' : 's'} por fileira
                                </div>
                                <div className="desenho">
                                    {Array.from({ length: colunas }).map((_, i) => (
                                        <span
                                            key={i}
                                            className={i === 0 ? "etiqueta-desenho primeira" : "etiqueta-desenho"}
                                            style={{
                                                width: `${larguraRetVw}vw`,
                                                height: `${alturaRetVw}vw`,
                                            }}
                                        >
                                            {i === 0 && <span className="seta-medida seta-h">&#8596;</span>}
                                            {i === 0 && <span className="seta-medida seta-v">&#8597;</span>}
                                        </span>
                                    ))}
                                </div>
                                <div className="legenda">{etqlargura}mm x {etqaltura}mm cada etiqueta</div>
                            </>
                            : <p className="resultado pendente">Informe a largura da etiqueta</p>
                        }

                    </div>
                </ DivDigital>

                {/* PAINEL PROVISÓRIO DE DEBUG — comentado antes do deploy, remover definitivamente depois de validar os cálculos
                <div style={{
                    position: 'fixed', bottom: 8, left: 8, zIndex: 9999,
                    background: 'rgba(0,0,0,0.88)', color: '#7CFC00', fontFamily: 'monospace',
                    fontSize: 12, padding: '10px 14px', borderRadius: 6, lineHeight: 1.7,
                    maxWidth: '92vw', maxHeight: '40vh', overflow: 'auto',
                }}>
                    <div style={{ color: '#fff', fontWeight: 'bold', marginBottom: 4 }}>[DEBUG — esboço de cálculo]</div>
                    <div>carreiras (largura): {debugCalc.carreiras}</div>
                    <div>total fileiras: {debugCalc.totalFileiras}</div>
                    <div>metro linear: {debugCalc.metroLinear?.toFixed(3)} ML</div>
                    <div>metro quadrado: {debugCalc.metroQuadrado?.toFixed(3)} M²</div>
                    <div>custo click: R$ {debugCalc.custoClick?.toFixed(2)}</div>
                    <div>custo MP: R$ {debugCalc.custoMP?.toFixed(2)}</div>
                    <div>custo corte: R$ {debugCalc.custoCorte?.toFixed(2)}</div>
                    <div>perda material (% progressivo {(debugCalc.percentualPerdaEfetivo * 100)?.toFixed(2)}%): R$ {debugCalc.perdaMaterial?.toFixed(2)}</div>
                    <div>margem (mult. progressivo {debugCalc.multiplicadorMargemEfetivo?.toFixed(3)}x): R$ {debugCalc.margem?.toFixed(2)}</div>
                    <div>subtotal (click+MP+corte+perda): R$ {debugCalc.subtotal?.toFixed(2)}</div>
                    <div>plastificação: {plastificacao ? 'SIM (+R$2,00/m² na MP)' : 'não'}</div>
                    <div>acabamento: {acabamento ? 'SIM (+30%)' : 'não'}</div>
                    <div>base p/ comissão (custos+perda+margem+acabamento): R$ {debugCalc.baseComissao?.toFixed(2)}</div>
                    <div>comissão (última, sobre tudo) digitada: {percComissao}% | efetiva: {debugCalc.comissaoPercEfetivo?.toFixed(1)}% | R$ {debugCalc.comissao?.toFixed(2)}</div>
                    <div>total antes do piso mínimo: R$ {debugCalc.totalAntesMinimo?.toFixed(2)} {debugCalc.totalAntesMinimo < 150 ? '(elevado ao piso de R$150)' : ''}</div>
                    <div style={{ color: '#fff', fontWeight: 'bold', marginTop: 4 }}>TOTAL: R$ {debugCalc.total?.toFixed(2)}</div>
                    <div>$M² (total / M²): R$ {debugCalc.valorPorM2?.toFixed(2)}</div>
                </div>
                */}
            </ Body>
        </>
    )
}
export default CalcDigital;
